import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BcmApiService } from './bcm-api.service';
import { BcmPermission } from './bcm-permissions-api.service';

export interface Module {
    id: number;
    parentId?: number;
    parent?: Module;
    children?: Module[];
    uniqueName: string;
    name: string;
    description: string;
    price: number;
    permissions: BcmPermission[];
    bundle?: any;
}

@Injectable({
    providedIn: 'root'
})
export class ModulesApiService extends BcmApiService {

    private RESOURCE_ENDPOINT = 'modules';

    getAll(params: HttpParams = new HttpParams()): Observable<Module[]> {
        return super.get<Module[]>(this.RESOURCE_ENDPOINT, params);
    }

}
